var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStripeRadioSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  focusable: "false",
  role: "presentation"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  fill: "none"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 3.5
})));
export default SvgStripeRadioSelected;